export default {
  namespaced  : true,

  state       : {
    paths : {
      webApi  : {
        login   : '/web-api/v1/auth/login',
        logout  : '/web-api/v1/auth/logout',
        home    : '/web-api/v1/home'
      }
    }
  },

  actions     : {
    async login(context, payload){
      let result = null;

      switch(context.rootState.authentication.method){
        case 'web':
          result = await context.dispatch('loginWithWeb', payload);
        break;

        case 'api':
          result = await context.dispatch('loginWithApi', payload);
        break;
      }

      return result;
    },

    async loginWithWeb(context, payload){
      const result = await context.dispatch('requests/apiRequest', {
        method      : 'post',
        requestPath : context.state.paths.webApi.login,
        parameters  : {
          email     : payload.email,
          password  : payload.password
        }
      }, {root:true});

      if(result.status === 200){
        await context.dispatch({
          type        : 'afterWebLoginSucceded',
          secureToken : result.data.secureToken,
        });
      }

      return result;
    },

    async afterWebLoginSucceded(context, payload){
      // 取得結果を保存します。
      await context.dispatch({
        type  : 'authentication/setAuth',
        data  : payload.secureToken,
      }, {root: true});

      // 取得したAuthorizeデータをもとにaxiosを再定義します。
      context.dispatch({
        type : 'requests/initializeRequest'
      }, {root: true});

      // sessionのクッキーを保存するために一度HOMEにGETアクセスします。
      await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'get',
        requestPath : context.state.paths.webApi.home,
      }, {root: true});
    },

    async logout(context, payload){
      let result = null;

      switch(context.rootState.authentication.method){
        case 'web':
          result = await context.dispatch('logoutWithWeb', payload);
        break;

        case 'api':
          result = await context.dispatch('logoutWithApi', payload);
        break;
      }

      return result;
    },

    async logoutWithWeb(context){
      const result = await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'post',
        requestPath : context.state.paths.webApi.logout
      }, {root:true});

      if( (result.status === 200) && (result.data.status === 'success') ){
        return {
          isSucceeded   : true,
          data          : result.data,
        }
      }else{
        return {
          isSucceeded   : false,
          data          : result.data,
        }
      }
    }
  }
}